import styled from 'styled-components'

import MEDIA from 'constants/media'

import Auto from 'assets/images/icons/insurance-types/Auto.svg'
import AutoColor from 'assets/images/icons/insurance-types/AutoColor.svg'
import Business from 'assets/images/icons/insurance-types/Business.svg'
import BusinessColor from 'assets/images/icons/insurance-types/BusinessColor.svg'
import Life from 'assets/images/icons/insurance-types/Life.svg'
import LifeColor from 'assets/images/icons/insurance-types/LifeColor.svg'
import Health from 'assets/images/icons/insurance-types/Health.svg'
import HealthColor from 'assets/images/icons/insurance-types/HealthColor.svg'
import Medicare from 'assets/images/icons/insurance-types/Medicare.svg'
import MedicareColor from 'assets/images/icons/insurance-types/MedicareColor.svg'
import Disability from 'assets/images/icons/insurance-types/Disability.svg'
import DisabilityColor from 'assets/images/icons/insurance-types/DisabilityColor.svg'
import Retirement from 'assets/images/icons/insurance-types/Retirement.svg'
import RetirementColor from 'assets/images/icons/insurance-types/RetirementColor.svg'
import Home from 'assets/images/icons/insurance-types/Home.svg'
import HomeColor from 'assets/images/icons/insurance-types/HomeColor.svg'

import {
  Label as BaseLabel,
  Radio as BaseRadio,
} from 'components/base/Form/Input/Radio/styles'

import { StyleProps } from './types'

const imageDimensions = {
  base: {
    width: 240,
    height: 152,
  },
  medium: {
    width: 380,
    height: 240,
  },
}

export const Image = styled.div<StyleProps>`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
  border-radius: 3px;
  transition: opacity 150ms;
  cursor: pointer;
  will-change: opacity, visibility;
  background-image: ${({
    insuranceType,
    isColor,
  }): string =>
    `url(${(insuranceType === 'auto' && ((isColor && AutoColor) || Auto)) ||
      (insuranceType === 'business' &&
        ((isColor && BusinessColor) || Business)) ||
      (insuranceType === 'health' && ((isColor && HealthColor) || Health)) ||
      (insuranceType === 'life' && ((isColor && LifeColor) || Life)) ||
      (insuranceType === 'home' && ((isColor && HomeColor) || Home)) ||
      (insuranceType === 'retirement' &&
        ((isColor && RetirementColor) || Retirement)) ||
      (insuranceType === 'disability' &&
        ((isColor && DisabilityColor) || Disability)) ||
      (insuranceType === 'medicare' &&
        ((isColor && MedicareColor) || Medicare))})`};

  width: ${imageDimensions.base.width}px;
  height: ${imageDimensions.base.height}px;
  ${MEDIA.medium`
    width: ${imageDimensions.medium.width}px;
    height: ${imageDimensions.medium.height}px;
  `}

  ${({
    isActive,
    isColor,
  }): string | undefined =>
    (isColor && `
      visibility: ${(isActive && 'visible') || 'hidden'};
      opacity: ${(isActive && 1) || 0};
      margin-top: -${imageDimensions.base.height}px;
    `) || undefined}
  ${MEDIA.medium`
    ${({ isColor }: StyleProps): string | false =>
    (isColor && `margin-top: -${imageDimensions.medium.height}px;`) || `
        opacity: 0.75;
        &:hover {
          opacity: 1;
        }
    `}
  `}
`

export const Container = styled.label`
  display: inline-block;
  vertical-align: middle;
  margin: 20px;
  justify-content: center;
`

export const Label = styled(BaseLabel)<StyleProps>`
  padding-left: ${({ insuranceType }): string | false => insuranceType === 'other' && '10px'};
`

export const Radio = styled(BaseRadio)``
